import React, {Fragment, useState} from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import {Card, CardHeader, CardContent, List, Divider, ListItem, ListItemText } from '@material-ui/core';
import BroadcastOn from '../dialogs/BroadcastOn';
import BroadcastOff from '../dialogs/BroadcastOff';
import EditUsers from '../dialogs/EditUsers';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    margin:16,
    marginBottom: '15px'
  }
}));

export default function Admin(props) {
    const { source, ...rest } = props;
    const classes = useStyles();

    const [openBroadcastOn, setBroadcastOn] = useState(false);
    const [openBroadcastOff, setBroadcastOff] = useState(false);
    const [openEditUsers, setOpenEditUsers] = useState(false);

    const handleOpenBroadcastOn = () => {
        setBroadcastOn(true)
    };
    const handleCloseBoadcastOn = () => {
        setBroadcastOn(false)
    };
    const handleOpenBroadcastOff = () => {
        setBroadcastOff(true)
    };
    const handleCloseBroadcastOff = () => {
        setBroadcastOff(false)
    };
    const handleOpenEditUsers = () => {
        setOpenEditUsers(true)
    };
    const handleCloseEditUsers = () => {
        setOpenEditUsers(false)
    };

    return (
        <div>
            <Card
                {...rest}
                className={clsx(classes.root)}
            >
                <CardHeader title="Admin"/>
                <CardContent>
                    <List className={classes.list} component="nav" aria-label="project list">
                        <Divider />
                        <Fragment>
                            <ListItem button onClick={handleOpenBroadcastOn}>
                                <ListItemText primary={'Broadcast'} secondary={'Ein zukünftiges Update wird an alle Benutzer mitgeteilt'}/>
                            </ListItem>
                        </Fragment>
                        <Divider />
                        <Fragment>
                            <ListItem button onClick={handleOpenBroadcastOff}>
                                <ListItemText primary={'Broadcast abbrechen'} secondary={'Wenn eine Update mitgeteilt wurde, wird diese abgebrochen'}/>
                            </ListItem>
                        </Fragment>
                        <Divider />
                        <Fragment>
                            <ListItem button onClick={handleOpenEditUsers}>
                                <ListItemText primary={'Benutzerverwaltung'} secondary={'Benutzer anlegen, löschen und editieren'}/>
                            </ListItem>
                        </Fragment>
                    </List>
                </CardContent>
            </Card>
            <BroadcastOn open={openBroadcastOn} onClose={handleCloseBoadcastOn}/>
            <BroadcastOff open={openBroadcastOff} onClose={handleCloseBroadcastOff}/>
            {openEditUsers && <EditUsers open={openEditUsers} onClose={handleCloseEditUsers}/>}
        </div>
    );
}